import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
    IItemsListAction2,
    IItemsListDataFetchResult,
    ISideListOptionsItem,
} from '@fi-shared/fi-items-list/fi-items-list';
import { ObjectTypes, SideListOptionType } from '@fi-shared/types';
import { ILoadDataArgs } from '@fi-shared/fi-items-list/fi-data-source-base.directive';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';
import {
    IChecklist2Parameter,
    IChecklistV2ForList,
} from '@fi-shared/checklist/checklist-v2';
import { IFiHttpPromise } from '@fi-shared/to-fi-promise';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { FiChecklist2ListBase } from '@fi-shared/checklist/fi-checklist2-list/fi-checklist2-list-base';

@Component({
    selector: 'fi-checklist2-list',
    templateUrl: './fi-checklist2-list.component.html',
    styleUrls: ['./fi-checklist2-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-list' },
    standalone: false,
})
export class FiChecklist2ListComponent extends FiChecklist2ListBase implements OnInit {
    public readonly defaultSortColumnName = 'DueDateTime';
    public readonly defaultSortDirection = false;
    public readonly objectType = ObjectTypes.CheckList;
    public readonly itemsListType = FiItemsListType.ChecklistsV2;

    protected readonly FiStateNames = FiStateNames;
    protected readonly FiProfileSizes = FiProfileSizes;

    public readonly auditMode: boolean = false;
    protected sideListOptions: ISideListOptionsItem[] =
        this.fiChecklist2SideListOptionsHelperService.getChecklistSideListOptions(this.auditMode);
    public actions: IItemsListAction2[] = this.fiChecklistActionsHelperService.getChecklistListActions({
        auditMode: false,
        templateMode: false,
        cdr: this.cdr,
        removeDataFn: (item) => this.removeData([item]),
    });
    protected getRowClassFn = (): string => 'cursor-pointer';

    public ngOnInit(): void {
        this.subscribeOnChecklistAnswersChangeForList({
            loadChecklistsFn: (checklistToScheduleIds) => {
                return new Promise<IChecklistV2ForList[]>((resolve, reject) => {
                    const parameter: IChecklist2Parameter = {
                        FetchParams: {
                            FetchItems: true,
                            FetchTotalCount: false,
                            FetchLightWeightObjects: false,
                        },
                        ChecklistToScheduleIds: checklistToScheduleIds,
                    };
                    this.fiChecklist2Service
                        .getChecklistsListData(parameter)
                        .then((listData) => resolve(listData.Items), reject);
                });
            },
        });
    }

    public loadListDataFn(loadArgs: ILoadDataArgs): Promise<IItemsListDataFetchResult<IChecklistV2ForList>> {
        const parameter = this.getItemsListParameter(loadArgs) as IChecklist2Parameter;
        return this.fiChecklist2Service.getChecklistsListData(parameter);
    }

    /*isOnDemand() {
        return this.filterType === SideListOptionType.OnDemandChecklists;
    }*/

    public deleteFn(itemsToDelete: IChecklistV2ForList[]): IFiHttpPromise<void> {
        throw new Error('not implemented');
    }

    protected showOptionsColumn(): boolean {
        return !this.extendedSearchMode;
    }
}
